/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class Role {
    getFixupPrototypeFunction() { return Role.fixupPrototype; }

    static newInstance(model: Partial<Role>): Role {
        let obj = Object.assign(new Role(), model);
        Role.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<Role>): Role {
        if (!model) return null;
        return Role.newInstance(<Role> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: Role) {
        if (!obj) return;

        models.Role.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: Role): boolean {
        Object.setPrototypeOf(obj, Role.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    id: string;

    name: string;

    role_type: string;

}
